"use client";

import type { Locale } from "@/lib/i18n/locales";
import { quizProgressCopy } from "@/lib/i18n/quiz-progress-copy";

import {
  BUS_QUIZ_CLEAR_EVENT,
  quizStorageKeyBelongsToLocale,
} from "./bus-quiz-storage";
import { event } from "@/lib/gtag";

type ClearQuizProgressLinkProps = {
  locale?: Locale;
  className?: string;
  label?: string;
};

export default function ClearQuizProgressLink({
  className,
  locale = "en",
  label,
}: ClearQuizProgressLinkProps) {
  const handleClear = () => {
    try {
      const keys = Object.keys(window.localStorage);
      for (const key of keys) {
        if (
          quizStorageKeyBelongsToLocale(key, locale)
        ) {
          window.localStorage.removeItem(key);
        }
      }
      window.dispatchEvent(new Event(BUS_QUIZ_CLEAR_EVENT));
      event("quiz_progress_clear", { source: "menu" });
    } catch (error) {
      console.warn("Failed to clear quiz progress", error);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClear}
      className={className}
      aria-label={quizProgressCopy(locale).clearAria}
    >
      {label ?? quizProgressCopy(locale).clear}
    </button>
  );
}
